import Cookies from '../providers/Cookies';

const checkForFeatureFlag = (featureId) => {
  const featureList = Cookies.get('features');
  if (featureList) {
    const featureArray = featureList.split(',');
    return featureArray.includes(featureId);
  }
  return false;
};

export default checkForFeatureFlag;
